export const activityCategoryFields = [{
        name: "description",
        title: "Descrizione"
    }];
